export default __webpack_public_path__ + "static/media/VBCLogo.c70a9e08.png";